import React, { useState } from 'react';
import './HomeContent.css';
import Container from '@material-ui/core/Container';
import Modal from 'react-modal';

function HomeContent() {
    const [showModal, setShowModal] = useState(false)
    const [activeModal, setActiveModal] = useState("")
    const [scroll, setScroll] = useState(true)
    window.addEventListener('scroll', (event) => {
        if (window.scrollY > 400) {
            setScroll('expand')
        }
        else {
            setScroll('')
        }
    })
    const handleOpenModal = (val) => {
        setActiveModal(val);
        setShowModal(true);
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setShowModal("");
    }
    return (
        <>
            {/* <div className="main-container">
                <title>LKM Portal</title>
                <img src="images/Home/new-turbocharged-v4.png" alt="banner" className="home-text-banner-img" />
            </div>
            <div className="banner-bar"></div> */}
            <div id="main" className="video-container">
            <h1 class="sr-only" tabIndex={0}>Turbocharged Learning</h1>
                <video width="100%" loop="true" autoplay="autoplay" muted>
                    <source src="images/Home/home-turbocharged-video-LTT.mp4" type="video/mp4" />
                </video>
            </div>
            <Container className='home-container' maxWidth="xl">
                <div className="new-home-container">
                    <div className="new-home-wrap">
                        <div className="new-home-row">
                            <div className="new-home-box">
                                {/* <h1>Turbocharged <span>Learning</span></h1>
                                <p>Enabling growth and change, making a meaningful impact for our people and business @ATCI</p> */}

                            </div>
                        </div>
                    </div>
                </div>
                <div className="lkm-insights-container">
                    {/* <h2>LKM Insights</h2> */}
                    <div className="lkm-insights-wrap">
                        <p className='enabiligTag'>Enabling growth and change, making a meaningful impact for our people and business @ATCI</p>
                        <div className="lkm-insights-row row1">
                            <div className="lkm-insights-box" >
                                <div className="img-content-box-holder">
                                    <img src="images/Home/ambrish-lead.png" alt="mentor" className='anupama-mentor' />
                                    <div className="content-holder">
                                        <p className='leaderName-1'>Ambrish Rastogi</p>
                                        {/* <p className="home-Lead">Lead-L&TT, Leadership Transformation, ATCI</p> */}
                                        <p className="home-Lead">Lead – Learning & Leadership Development (ATC-GN)</p>
                                    </div>
                                </div>
                                {scroll === "expand" &&
                                    <div className='expand-smooth'>
                                        {/* <p>"I am so excited to share and celebrate the journey of Learning and Knowledge Management - LKM, where we create and transform new and existing talent to enable growth across ATCI.</p>
                                        <p>We have come a long way in creating a unique and dynamic learning environment that helps unlock creative opportunities. Learning continues unabated, at scale, across a broad spectrum of areas. We designed exclusive programs for the leadership, technology and delivery workforce, provided a plethora of digital learning platforms, evangelized in-demand and market-driven offerings and initiatives, and moved new hire learning to virtual environments. </p>
                                        <p>A huge callout to our talent sponsors and their teams across markets and practices for partnering with us to develop and execute the learning charter at ATCI, and kudos to our incredible LKM team for consistently delivering to the delight of our stakeholders and consumers.</p>
                                        <p>This is a pivotal juncture at LKM, where we are creating limitless learning to improve our people, redefine business, and pioneer continuous learning. Join me to experience LKM right here, right now!"</p> */}
                                        <p>Learning & Talent Transformation (L&TT) powers the massive skill transformation of our people, enabling them in digital technologies to fulfill a strong demand to build advanced skills and lead in today's dynamic business environment.</p>
                                        <p>Driving continuous learning at scale, L&TT invests in creating and reinventing ATCI talent that is future-ready by establishing a responsive learning ecosystem and introducing innovative learning approaches across a spectrum of offerings for all career levels, aligned to immediate business-specific requirements.</p>
                                        <p>Join me to experience L&TT right here, right now!</p>
                                    </div>}
                            </div>
                        </div>
                        {/* <div className="lkm-insights-row row2">
                            <div className="lkm-insights-box">
                                <img src="images/Home/Anupama_newimg.png" alt="mentor" className='mentor-img' />
                                <h3>Anupama Nithyanand</h3>
                                <p className="home-Lead">Lead - Learning and Knowledge Management, ATCI</p>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="whats-trend-conatiner">
                    <h2>L&TT - A Closer Look</h2>
                    <p>Elevating relevant talent through continuous learning opportunities at speed and at scale.</p>
                    <div className="whats-trend-wrap">
                        <div className="whats-trend-row">
                            <div className="whats-trend-box box1">
                                <img src="images/Home/Overview-4px-space-refined.png" alt="Overview Icon" className='overview-img' />
                                <h3>Overview</h3>
                                {/* <p>Enable talent supply for the future by transforming raw talent and fast-tracking careers. <span style={{ visibility: 'hidden' }}>in learning and innovation. in learning and innovation.</span> </p> */}
                                <p>Enabling talent creation for the future by transforming people and fast-tracking careers.<span style={{ visibility: 'hidden' }}>in learning and and innovation and innovation.</span></p>
                                <p><a href="https://atci.lkm.accenture.com/overview">Explore More <img src="images/Home/Explore arrow.png" alt="" /></a></p>
                            </div>
                        </div>
                        <div className="whats-trend-row">
                            <div className="whats-trend-box">
                                <img src="images/Home/Offerings-4px-space-refined.png" alt="Offerings Icon" className='overview-img' />
                                <h3>Offerings </h3>
                                {/* <p>Offer customized, hands-on, experience-led massive learning and certifications at scale. <span style={{ visibility: 'hidden' }}>in learning and innovation.</span></p> */}
                                <p>A broad spectrum of hands-on, experience-led massive learning and certifications at scale.<span style={{ visibility: 'hidden' }}>in learning and and innovation.</span></p>
                                <p><a href="https://atci.lkm.accenture.com/offerings">Explore More <img src="images/Home/Explore arrow.png" alt="" /></a></p>
                            </div>
                        </div>
                        <div className="whats-trend-row">
                            <div className="whats-trend-box">
                                <img src="images/Home/Endorsements-4px-space-refined.png" alt="Endorsements Icon" className='overview-img' />
                                <h3>Endorsements </h3>
                                <p>Hear from our esteemed sponsors and participants on path-breaking learning offerings. <span style={{ visibility: 'hidden' }}>in learning and and innovation.</span></p>
                                <p><a href="https://atci.lkm.accenture.com/Endorsements">Explore More <img src="images/Home/Explore arrow.png" alt="" /></a></p>
                            </div>
                        </div>
                        <div className="whats-trend-row">
                            <div className="whats-trend-box box4">
                                <img src="images/Home/Recognition-4px-space-refined.png" alt="Recognitions Icon" className='overview-img' />
                                <h3>Recognitions</h3>
                                <p>Numerous prestigious awards and recognitions won at international and national forums for excellence in learning and innovation. <span style={{ visibility: 'hidden' }}> innovation.</span></p>
                                <p><a href="https://atci.lkm.accenture.com/awards">Explore More <img src="images/Home/Explore arrow.png" alt="" /></a> </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="stayknow-container">
                    <div className="stay-wrap">
                        <div className="stay-row row1">
                            <div className="stay-box">
                                <h2>Stay in the Know</h2>
                                <p>Explore how L&TT is fostering a culture of learning to nurture and grow the ATCI talent.</p>
                                {/* <p><a href="https://atci.lkm.accenture.com/stayknow">Explore More <img src="images/Home/Explore arrow.png" alt="" /></a> </p> */}
                            </div>
                        </div>
                        <div className="stay-row row2">
                            <div className="stay-box">
                                {/* <img src="images/Home/Recognition-4px-space-refined.png" alt="mentor" className='ourleads-img' /> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="learncard-container">
                    <div className="learncard-wrap">
                        <div className="learncard-row">
                            <div className="learncard-box">
                                <div className="learncard-imgzoom">
                                    <a href="https://atci.lkm.accenture.com/learning-calendar/" target="_blank" tabIndex={0}>
                                        <img src="images/Offerings/calendar.jpg" alt="Calendar" className='learncard-img' />
                                    </a>
                                </div>
                                <h3>L&TT Calendar</h3>
                                <p>Access learning calendar that enlists L&TT's course offerings on Technology, Delivery, Innovation for targeted ATCI learners. <span style={{ visibility: 'hidden' }}>Technology, Delivery, and</span> </p>
                                <p><a href="https://atci.lkm.accenture.com/learning-calendar/" target="_blank">Explore More <img src="images/Offerings/Go Arrow.png" alt="" /></a></p>
                            </div>
                        </div>
                        <div className="learncard-row">
                            <div className="learncard-box" >
                                <div className="learncard-imgzoom">
                                    <a href="https://atci.lkm.accenture.com/LKM-eCatalog/home" target='_blank'>
                                        <img src="images/Offerings/img_1.png" alt="eCatalog" className='learncard-img' />
                                    </a>
                                </div>
                                <h3>L&TT eCatalogs</h3>
                                <p>Explore the easy-to-navigate, highly interactive and detailed view of L&TT offerings across three categories: Technology, Delivery, and Innovation.</p>
                                <p><a href="https://atci.lkm.accenture.com/LKM-eCatalog/home" target="_blank">Explore More <img src="images/Offerings/Go Arrow.png" alt="" /></a></p>
                            </div>
                        </div>
                        <div className="learncard-row">
                            <div className="learncard-box" >
                                <div className="learncard-imgzoom">
                                    <a onClick={() => handleOpenModal("image2")} tabIndex={0}>
                                        <img src="images/Offerings/img_4.png" alt="Events" className='learncard-img' />
                                    </a>
                                </div>
                                <h3>Learning Events</h3>
                                <p>Hackathons and ideathons hosted by L&TT, to equip ATCI to stay updated with the latest tech advancements. <span style={{ visibility: 'hidden' }}>Technology, Delivery, and Innovation.</span></p>
                                <div className='last-card-modal' onClick={() => handleOpenModal("image2")} tabIndex={0}><a className="digital_tag">View More <img src="images/Offerings/Go Arrow.png" alt="" className='Arrow-img' /></a> </div>
                            </div>
                        </div>
                        <Modal
                            isOpen={
                                showModal &&
                                activeModal === "image2"
                            }
                            onRequestClose={() => setShowModal(false)}
                            // contentLabel="login Modal"
                            style={{
                                overlay: {
                                    backgroundColor: 'rgba(0, 0, 0, 0.75)'
                                }
                            }}
                        >
                            <button className="close-button" onClick={handleCloseModal}>X</button>

                            {/* <h3 className="content-title">Quality Engineering</h3>
                            <ul>
                                <li><span>LKM QE Hackathons in AI and Testing in Cloud:</span> Hackathon Based learning program on 2 parallel tracks: AI in Testing and Testing in Cloud</li>
                                <li><span>QE GALA '22:</span> Learning Symposium specially curated for Quality Engineering and testing community in ATCI. It was week long fun filled event with epxerts on niche QE Skills</li>
                                <li><span>Concur:</span> A people developer initiative driven collaboratively by LKM and project to share real-time experiences. Completed 3 episodes  with &#62;500 participants</li>
                            </ul>
                            <h3 className="content-title">Mainframe</h3>
                            <ul>
                                <li><span>Mainframe Hackathon:</span> Hackathon on Mainframe Automation using REXX.</li>
                            </ul>
                            <h3 className="content-title">Sustainability</h3>
                            <ul>
                                <li><span>ATCI IWD -</span> Sustainability Initiative: Ctrl + Hack + Insert: Sustainability ideathon to help design a sustainable future.</li>
                                <li><span>(e)Mission-zero:</span> NA I&D Initiative on Sustained Applied Learning with Purpose and at Scale to accelerate Sustainability Goals. <br />Start a ground-up movement on Sustainability across our teams – learning about changing industry practices across the 5 industry groups and how it applies to coding. Move to green coding practices and collaborate with our clients to get them closer to net zero carbon.</li>
                            </ul> */}

                            <h3 className="learning-events-title">Learning Events</h3>
                                <table className='learning-events-table'>
                                <thead>
                                    <tr>
                                        <th>Categories</th>
                                        <th>Name of Learning Events</th>
                                        <th>Events Duration/Timeline</th>
                                        <th>Target Audience</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Emerging Platforms</td>
                                        <td>Compose & Connect Week</td>
                                        <td>16-Jan-2023 To 20-Jan-2023</td>
                                        <td>ATCI - Song Community</td>
                                        <td>Compose and Connect week with about 100+ participation each day spread across 10 hrs of learning and engagement brought together by partners like Commercetools , Bloomreach , Contentful , Cloudinary & Algolia from across the globe.</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3">Automation</td>
                                        <td>High-Tech Women Edge - Automation Track</td>
                                        <td>Mar-2023 To May-2023</td>
                                        <td>ATCI - AM and Above</td>
                                        <td>HIGH-TECH WOMEN EDGE is about giving women in tech the edge they need to take on challenging technology roles. This is a specialized, custom, demand-driven program in focused technology areas that enables candidates to be deployed onto projects to apply their training. It is enabled by a mentorship framework – that helps candidates through the process of learning</td>
                                    </tr>
                                    <tr>
                                        {/* <td>Automation</td> */}
                                        <td>MAINFRAME AUTOMATION ROADSHOW USING REXX</td>
                                        <td>FY23, H2</td>
                                        <td>All Career levels</td>
                                        <td>MAINFRAME AUTOMATION ROADSHOW USING REXX is a learning series designed for ATCi mainframe practitioner. The whole aim of the learning series is to create automation tools in mainframe using the scripting language REXX.As part of this learning series mainframe sme’s at L&TT Mainframe team is going to showcase different types automation in mainframe using REXX.</td>
                                    </tr>
                                    <tr>
                                        {/* <td>Automation</td> */}
                                        <td>TechQE Expert Voices - Episode 1 - AccelQ Codeless Automation</td>
                                        <td>Feb 23rd, 2023</td>
                                        <td>All Career levels</td>
                                        <td>TechQE Expert Voices is a learning event specific to industry groups planned as a series of sessions. This will help the testing community to  witness a transformation in the  QE process through the power of AI and Codeless platforms. These sessions are conducted by various vendors and different test automation experts join to share their experiences to entire ATCI Testing community</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2">IE - Network</td>
                                        <td>Network Learning Connect</td>
                                        <td>Monthly </td>
                                        <td>All Career levels</td>
                                        <td>“Network Learning Connect” is a webinar series designed exclusively for ATCI IE Network capability resources. This program creates and nurtures people to be equipped with latest network concepts overview and aims to infuse network tools and technologies in an engagement, making them to be future ready to help clients powerfully lead in the New and staying ahead of the talent curve. </td>
                                    </tr>
                                    <tr>
                                        {/* <td>Infrastructure Engineering</td> */}
                                        <td>Multi sklling program</td>
                                        <td>FY23</td>
                                        <td>All Career levels</td>
                                        <td>The program is designed with the expectation that an engineer will acquire and demonstrate expertise in multiple skills in the Infrastructure world.</td>
                                    </tr>
                                </tbody>
                                </table>

                            <button className="digitalclose-btn" onClick={handleCloseModal}>Close</button>
                        </Modal>
                        
                    </div>
                    <div className="learncard-wrap">
                    <div className="learncard-row">
                            <div className="learncard-box" >
                                <div className="learncard-imgzoom">
                                    <a tabIndex={0}>
                                        <img src="images/Offerings/Learning Paths.png" alt="Specializations" className='learncard-img' />
                                    </a>
                                </div>
                                <h3>Learning Paths/Specializations</h3>
                                <p>Learning Paths to build increasing levels of knowledge and deep expertise to grow in various career roles. </p>
                                {/* <p><a href="#">Explore More <img src="images/Offerings/Go Arrow.png" alt="" className='Arrow-img' /></a></p> */}
                                <p style={{ fontFamily: "graphik-bold" }}>Coming soon...</p>
                            </div>
                        </div>
                        {/* <div className="learncard-row" >
                            <div className="learncard-box" >
                                <div className="learncard-imgzoom" onClick={() => handleOpenModal("image1")}>
                                    <img src="images/Offerings/DigitalLearningsv3.png" alt="Learnings" className='learncard-img' />
                                </div>
                                <h3>Digital Learning Platforms</h3>
                                <p>Partnerships established by LKM with leading global digital learning platforms for self-paced, self-driven learning. </p>
                                <div className='last-card-modal' onClick={() => handleOpenModal("image1")}><a>View More <img src="images/Offerings/Go Arrow.png" alt="" className='Arrow-img' /></a> </div>
                            </div>
                        </div>
                        <Modal
                            isOpen={
                                showModal &&
                                activeModal === "image1"
                            }
                            onRequestClose={() => setShowModal(false)}
                            // contentLabel="login Modal"
                            style={{
                                overlay: {
                                    backgroundColor: 'rgba(0, 0, 0, 0.75)'
                                }
                            }}
                        >
                            <button className="close-button" onClick={handleCloseModal}>X</button>
                            <h3 className="content-title">Digital Learning Platforms</h3>
                            <p className="popup-content">We have established partnerships and collaborations with popular international digital platforms to curate blended, personalized multi-channel learning experiences and leveraged content authored by renowned global universities/industry experts. Off-the-shelf content from these digital platforms flows seamlessly into our blended learning programs. Access to these digital platforms are subscription-based to targeted learners and by invite only. Some of these digital platforms include:</p>

                            <div className="digitalpopup-wrap">
                                <div className="digitalpopup-row">
                                    <div className="digitalpopup-box">
                                        <img src="images/Home/Group 20.svg" alt="mentor" className='digital-img' />
                                        <h3>A Cloud Guru</h3>
                                        <p>Cloud Learning</p>
                                        <p className='digital-contact'><a href="mailto:rahul.suresh.ghali"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a></p>
                                    </div>
                                </div>
                                <div className="digitalpopup-row">
                                    <div className="digitalpopup-box">
                                        <img src="images/Home/Group 22.svg" alt="mentor" className='digital-img' />
                                        <h3>Coursera</h3>
                                        <p>MOOCs for Technology, Business, Industry Specializations</p>
                                        <p className='digital-contact'><a href="mailto:vanitadevi.patil"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a></p>
                                    </div>
                                </div>
                                <div className="digitalpopup-row">
                                    <div className="digitalpopup-box">
                                        <img src="images/Home/Group 24.svg" alt="mentor" className='digital-img' />
                                        <h3>Deep Knowledge Portal</h3>
                                        <p>Homegrown Learning Portal </p>
                                        <p className='digital-contact'><a href="mailto:shantanu.a.biswas"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a></p>
                                    </div>
                                </div>

                                <div className="digitalpopup-row">
                                    <div className="digitalpopup-box">
                                        <img src="images/Home/Group 26.svg" alt="mentor" className='digital-img' />
                                        <h3>Desire2Learn </h3>
                                        <p>Entry-level learning portal</p>
                                        <p className='digital-contact'><a href="mailto:amitabh.kannal"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="digitalpopup-wrap">
                                <div className="digitalpopup-row">
                                    <div className="digitalpopup-box">
                                        <img src="images/Home/Group 28.svg" alt="mentor" className='digital-img' />
                                        <h3>Oracle</h3>
                                        <p>Unlimited Learning Subscription</p>
                                        <p className='digital-contact'><a href="mailto:praveen.rajaram"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a></p>
                                    </div>
                                </div>
                                <div className="digitalpopup-row">
                                    <div className="digitalpopup-box">
                                        <img src="images/Home/Group 30.svg" alt="mentor" className='digital-img' />
                                        <h3>Pluralsight</h3>
                                        <p>Online Courses for Technology Upskilling </p>
                                        <p className='digital-contact'><a href="mailto:vanitadevi.patil"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a></p>
                                    </div>
                                </div>

                                <div className="digitalpopup-row">
                                    <div className="digitalpopup-box">
                                        <img src="images/Home/Group 32.svg" alt="mentor" className='digital-img' />
                                        <h3>Qwiklabs</h3>
                                        <p>Cloud Learning</p>
                                        <p className='digital-contact'><a href="mailto:rahul.suresh.ghali"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a></p>
                                    </div>
                                </div>
                                <div className="digitalpopup-row">
                                    <div className="digitalpopup-box">
                                        <img src="images/Home/Group 38.svg" alt="mentor" className='digital-img' />
                                        <h3>SalesForce myTrailhead</h3>
                                        <p>Salesforce Learning</p>
                                        <p className='digital-contact'><a href="mailto:narayan.hosabettu"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="digitalpopup-wrap">
                                <div className="digitalpopup-row digital_platform_col">
                                    <div className="digitalpopup-box">
                                        <img src="images/Home/Group 36.svg" alt="mentor" className='digital-img' />
                                        <h3>SAP</h3>
                                        <p>Partner Learning Hub</p>
                                        <p className='digital-contact'><a href="mailto:s.saraswathi"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a></p>
                                    </div>
                                </div>

                                <div className="digitalpopup-row">
                                    <div className="digitalpopup-box">
                                        <img src="images/Home/Group 34.svg" alt="mentor" className='digital-img' />
                                        <h3>TecStac</h3>
                                        <p>Entry-level Job Readiness</p>
                                        <p className='digital-contact'><a href="mailto:amitabh.kannal"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a></p>
                                    </div>
                                </div>
                            </div>
                            <button className="digitalclose-btn" onClick={handleCloseModal}>Close</button>
                        </Modal> */}
                        {/* <div className="learncard-row" id='learning-events'>
                            <div className="learncard-box" >
                                <div className="learncard-imgzoom">
                                    <a onClick={() => handleOpenModal("image3")}>
                                        <img src="images/Offerings/Learning-infracturev1.jpg" alt="Events" className='learncard-img' />
                                    </a>
                                </div>
                                <h3>Learning Infrastructure</h3>
                                <p>Learning infrastructure includes logistics, applications, services, and people that provide and support environments for learning.</p>
                                <div className='last-card-modal' onClick={() => handleOpenModal("image3")}><a className="digital_tag">View More <img src="images/Offerings/Go Arrow.png" alt="" className='Arrow-img' /></a> </div>
                            </div>
                        </div>
                        <Modal
                            isOpen={
                                showModal &&
                                activeModal === "image3"
                            }
                            onRequestClose={() => setShowModal(false)}
                            // contentLabel="login Modal"
                            style={{
                                overlay: {
                                    backgroundColor: 'rgba(0, 0, 0, 0.75)'
                                }
                            }}
                        >
                            <button className="close-button" onClick={handleCloseModal}>X</button>
                            <h3 className="content-title">1. Cloud Infrastructure</h3>
                            <p>Participants who attend the program organized by LKM will be provided required setup over Cloud Platform to complete labs, hands-on. This setup is provisioned only for participants for the entire duration of the program.</p>
                            <h3 className="content-title">2. Physical Infrastructure</h3>
                            <p>Training rooms are setup across ATCI locations. There are different types of training rooms:</p>
                            <ul>
                                <li>Regular Training Room</li>
                                <li>ACLC</li>
                                <li>Executive Room</li>
                                <li>Liquid Training Room</li>
                                <li>DT Studio</li>
                            </ul>
                            <p>LKM reserves the type of room suitable for the program. Currently, the training rooms do not have computers deployed as employees are expected to carry their own laptops to the program sessions. The details of the types of training rooms available in ATCI can be accessed from here. These rooms are internally reserved by the LKM team members and these training rooms cannot be booked for any other events except learning events.</p>
                            <button className="digitalclose-btn" onClick={handleCloseModal}>Close</button>
                        </Modal> */}
                    </div>
                </div>
            </Container>
            <div className="our-leads-bg">
                <Container className='home-container' maxWidth="xl">
                    <div className="our-leads-container">
                        <div className="our-leads-wrap">
                            <div className="our-leads-row row1">
                                <div className="our-leads-box">
                                    {/* <h2>Our Leads</h2> */}
                                    {/* <p><a href="https://atci.lkm.accenture.com/OurLeads">Our Leads <img src="images/Home/Explore arrow.png" alt="" /></a> </p> */}
                                    <p><a href="https://atci.lkm.accenture.com/OurLeads">Our Leads </a> </p>
                                    <h2>Meet our leads who make it happen!</h2>
                                </div>
                            </div>
                            <div className="our-leads-row row2">
                                <div className="our-leads-box">
                                    {/* <img src="images/Home/Recognition-4px-space-refined.png" alt="mentor" className='ourleads-img' /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
            
        </>
    )
}

export default HomeContent;
